import styled from 'styled-components';
import { theme } from '_constants/theme';
import { config } from '_config';
import { ROUTES } from '_constants/routes';
import Link from 'next/link';
import Button from '@mui/material/Button';
import * as React from 'react';
import { useRouter } from 'next/router';
const { colors, devices, fontSizes, spaces } = theme;

const StyledSearchTrademarkGeniusGraySection = styled.div`
  margin-top: 100px;
  padding-top: 100px;
  padding-bottom: 100px;
  background: #ecedf1;
  @media ${devices.tablet} {
    margin-top: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
`;
const StyledContainer = styled.div`
  max-width: 1400px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  gap: 50px;
  @media ${devices.tablet} {
    gap: 10px;
    flex-direction: column;
    padding-left: 16px;
    padding-right: 16px;
  }
`;
const StyledContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  flex: 1 1 0;
  p {
    color: #03589c;
    width: 100%;
    font-family: 'MontserratRegular';
    font-style: normal;
    font-size: ${fontSizes.regular}px;
    line-height: 18px;
    text-align: left;
  }
  img {
    max-width: 200px;
  }
`;
const StyledHeader = styled.div`
  color: #7b848d;
  font-family: 'MontserratBold';
  font-style: normal;
  font-size: 28px;
  width: 100%;
  padding-left: 175px;
  margin-bottom: -1rem;
  @media ${devices.tablet} {
    padding-left: 0px;
    text-align: center;
  }
`;
const StyledItemContainer = styled.div`
  display: flex;
  gap: 6px;
  flex-direction: column;
`;
const StyledItemTitle = styled.div`
  color: #03589c;
  font-family: 'MontserratBold';
  ${fontSizes.large};
`;

const StyledItem = styled.div`
  display: flex;
  gap: 50px;
  img {
    max-width: 125px;
  }
  color: #7b848d;
  width: 100%;
  font-family: 'MontserratRegular';
  font-style: normal;
  font-size: ${fontSizes.regular}px;
  line-height: 24px;
  text-align: left;
  align-items: center;
`;

const items = [
  {
    image: `${config.basePath}/monitoring3.png`,
    title: 'User-Friendly Approach',
    text: 'TradeMark Genius streamlines the trademark application process, ensuring a hassle-free experience for businesses of all sizes.',
  },
  {
    image: `${config.basePath}/step-process-1.png`,
    title: 'Comprehensive Search',
    text: 'After performing searches using the USPTO database, begin by completing a questionnaire that provides essential information about your business and trademark.\n',
  },
  {
    image: `${config.basePath}/step-process-3.png`,
    title: 'Expert Review',
    text: "Our team of trademark application experts reviews the information you provide, ensuring accuracy and completeness. We conduct a meticulous direct-hit search to maximize the application's chances of success.",
  },
  {
    image: `${config.basePath}/step-process-2.png`,
    title: 'Electronic Filing',
    text: 'We handle the filing of your application electronically with the USPTO, simplifying the bureaucratic process and saving you time and effort.',
  },
  {
    image: `${config.basePath}/faq-lockup.png`,
    title: 'Save Your Time',
    text: 'We know you’re busy, and that’s why you’ve come to us as the experts. Our experts take the process off your plate, assuring you that your application is left in good hands.',
  },
];
const SearchTrademarkGeniusGraySection = () => {
  const router = useRouter();
  return (
    <StyledSearchTrademarkGeniusGraySection>
      <StyledContainer>
        <StyledContainerColumn>
          <div className="sides">
            <div className="side-box-wrapper">
              <div className="side-box-back-2"></div>
              <div className="side-box-back"></div>
              <div
                className="side-box"
                style={{ marginTop: '25px', marginBottom: '30px' }}
              >
                <div className="header-line"></div>
                <h4>Comprehensive Trademark Search</h4>
                <h5>
                  Make sure your trademark is available before you apply to
                  register it
                </h5>
                <div
                  className="orange-box"
                  style={{ cursor: 'pointer' }}
                  onClick={() => router.push(ROUTES.comprehensiveSearchFiling)}
                >
                  <div className="star"></div>
                  <div className="price-wrapper">
                    <div className="price">$149.00</div>
                    <p style={{ textAlign: 'center' }}>per trademark</p>
                  </div>
                  <div className="star"></div>
                </div>
                <ul>
                  <li>
                    <span></span>
                    <p>Email delivery of comprehensive detailed report</p>
                  </li>
                  <li>
                    <span></span>
                    <p>
                      Findings of similar names, logos or slogans registered or
                      pending with the USPTO
                    </p>
                  </li>
                </ul>
                <Link href={`/comprehensive-search-report`}>
                  <Button>Start Now</Button>
                </Link>
              </div>
            </div>
          </div>
        </StyledContainerColumn>
        <StyledContainerColumn>
          <StyledHeader>Trademark Genius Process</StyledHeader>
          {items.map((item, j) => (
            <StyledItem>
              <img src={item.image} alt="" layout="fill" />
              <StyledItemContainer>
                <StyledItemTitle>{item.title}</StyledItemTitle>
                {item.text}
              </StyledItemContainer>
            </StyledItem>
          ))}
        </StyledContainerColumn>
      </StyledContainer>
    </StyledSearchTrademarkGeniusGraySection>
  );
};

export default SearchTrademarkGeniusGraySection;
